import { Monitor } from "@/components/models/Monitor";
import { Badge } from "@/components/ui/Badge";

export function formatDuration(seconds: number | undefined): string {
  if (seconds === 0) {
    return "";
  }

  if (!seconds) {
    return "";
  }

  if (seconds < 60) {
    return `${seconds}s`;
  }

  const minutes = Math.floor(seconds / 60);
  const last_seconds = seconds % 60;

  if (minutes < 60) {
    if (last_seconds === 0) {
      return `${minutes}m`;
    } else {
      return `${minutes}m ${last_seconds}s`;
    }
  }

  const hours = Math.floor(minutes / 60);
  const last_minutes = minutes % 60;

  if (hours < 24) {
    // return `${hours}h ${last_minutes}m ${last_seconds}s`

    if (last_minutes === 0) {
      return `${hours}h`;
    } else {
      return `${hours}h ${last_minutes}m`;
    }
  }

  const days = Math.floor(hours / 24);
  const last_hours = hours % 24;

  // return `${days}d ${last_hours}h ${last_minutes}m ${last_seconds}s`
  return `${days}d ${last_hours}h ${last_minutes}m`;
}

export function MonitorStatusImage({ monitor }: { monitor: Monitor }) {
  // if (!monitor.active) {
  //     return <div className='rounded-full bg-amber-500 w-4 h-4' />
  // }

  switch (monitor.last_status) {
    case "up":
      return <div className="pulse-lime w-4 h-4" />;

    case "no_data":
      return <div className="rounded-full bg-gray-500 w-4 h-4" />;

    default:
      return <div className="pulse-red w-4 h-4" />;
  }
}

export function MonitorStatusLabel({ monitor }: { monitor: Monitor }) {
  switch (monitor.last_status) {
    case "up":
      return <Badge variant="success">Up</Badge>;

    case "no_data":
      return <Badge variant="outline">Waiting for data</Badge>;

    default:
      return <Badge variant="destructive">Down</Badge>;
  }
}

export function MonitorTypeBadge({ monitor }: { monitor: Monitor }) {
  if (monitor.settings.https) {
    return (
      <span className="ml-3 inline-flex items-center rounded-sm bg-yellow-100 px-2 py-0.5 text-xs font-medium text-yellow-800">
        http
      </span>
    );
  }

  if (monitor.settings.tcp) {
    return (
      <span className="ml-3 inline-flex items-center rounded-sm bg-yellow-100 px-2 py-0.5 text-xs font-medium text-yellow-800">
        tcp
      </span>
    );
  }

  // if (monitor.settings.ping) {
  return (
    <span className="ml-3 inline-flex items-center rounded-sm bg-yellow-100 px-2 py-0.5 text-xs font-medium text-yellow-800">
      ping
    </span>
  );
}

export function MonitorSettingsShort(monitor: Monitor) {
  if (monitor.settings.https) {
    const url = monitor.settings.https?.url;
    // Strip out user:pass credentials from URL for display
    const sanitizedUrl = url ? url.replace(/^(https?:\/\/)([^@]+)@/, "$1") : "";
    return `${monitor.settings.https?.http_method?.toUpperCase() || "HEAD"} ${sanitizedUrl}`;
  }

  if (monitor.settings.tcp) {
    // return `${monitor.settings.tcp?.host}:${monitor.settings.tcp?.port}`
    return monitor.settings.tcp.url;
  }

  if (monitor.settings.ping) {
    // return `${monitor.settings.ping?.host}`
    return monitor.settings.ping.url;
  }
}
